/** Compresse une data URL image pour l’autosave / API (évite les 413). */

const DEFAULT_MAX = 720;
const DEFAULT_QUALITY = 0.82;
/** Sous ce poids approx., on ne recompresse pas. */
const SKIP_UNDER_BYTES = 160_000;

export function estimateDataUrlBytes(dataUrl: string): number {
    const i = dataUrl.indexOf(',');
    if (i < 0) return dataUrl.length;
    return Math.ceil((dataUrl.length - i - 1) * 0.75);
}

export function compressImageDataUrl(
    dataUrl: string,
    options?: { maxSize?: number; quality?: number }
): Promise<string> {
    if (!dataUrl || !dataUrl.startsWith('data:image/')) {
        return Promise.resolve(dataUrl);
    }

    const maxSize = options?.maxSize ?? DEFAULT_MAX;
    const quality = options?.quality ?? DEFAULT_QUALITY;

    if (estimateDataUrlBytes(dataUrl) < SKIP_UNDER_BYTES) {
        return Promise.resolve(dataUrl);
    }

    return new Promise((resolve) => {
        const img = new Image();
        img.onload = () => {
            let { width, height } = img;
            const ratio = Math.min(maxSize / width, maxSize / height, 1);
            width = Math.max(1, Math.round(width * ratio));
            height = Math.max(1, Math.round(height * ratio));

            const canvas = document.createElement('canvas');
            canvas.width = width;
            canvas.height = height;
            const ctx = canvas.getContext('2d');
            if (!ctx) {
                resolve(dataUrl);
                return;
            }
            ctx.fillStyle = '#ffffff';
            ctx.fillRect(0, 0, width, height);
            ctx.drawImage(img, 0, 0, width, height);

            let out = canvas.toDataURL('image/jpeg', quality);
            // Si encore trop gros, baisser la qualité
            if (estimateDataUrlBytes(out) > 900_000) {
                out = canvas.toDataURL('image/jpeg', 0.65);
            }
            resolve(out.length < dataUrl.length ? out : dataUrl);
        };
        img.onerror = () => resolve(dataUrl);
        img.src = dataUrl;
    });
}

export async function compressImageFile(file: File): Promise<string> {
    const raw = await new Promise<string>((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(String(reader.result || ''));
        reader.onerror = () => reject(reader.error);
        reader.readAsDataURL(file);
    });
    return compressImageDataUrl(raw);
}
